import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Clock } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { salonInfo } from '../data/mockData';

const Pricelist = () => {
  const priceCategories = [
    {
      title: "Herren Services",
      services: [
        {
          category: "Herren Waschen Schneiden Föhnen",
          items: [
            { name: "30 Minuten", duration: "30 Min", price: "45 €" },
            { name: "45 Minuten", duration: "45 Min", price: "50 €" },
            { name: "60 Minuten", duration: "60 Min", price: "55 €" }
          ]
        },
        {
          category: "Herren Grauhaar Kaschierung",
          items: [
            { name: "Grauhaar Kaschierung", duration: "40 Min", price: "30 €" }
          ]
        }
      ]
    },
    {
      title: "Damen Haarschnitte & Styling",
      services: [
        {
          category: "Damen Waschen Schneiden Föhnen",
          items: [
            { name: "Kurz", duration: "40 Min", price: "66 €" },
            { name: "Mittel", duration: "50 Min", price: "72 €" },
            { name: "Lang", duration: "60 Min", price: "82 €" }
          ]
        },
        {
          category: "Damen Waschen Föhnen",
          items: [
            { name: "Kurz", duration: "30 Min", price: "41 €" },
            { name: "Mittel", duration: "40 Min", price: "47 €" },
            { name: "Lang", duration: "60 Min", price: "61 €" }
          ]
        },
        {
          category: "Damen Waschen Legen",
          items: [
            { name: "Kurz", duration: "30 Min", price: "38 €" },
            { name: "Mittel", duration: "45 Min", price: "45 €" },
            { name: "Lang", duration: "60 Min", price: "55 €" }
          ]
        },
        {
          category: "Damen Cut and Go",
          items: [
            { name: "Kurz", duration: "30 Min", price: "45 €" },
            { name: "Mittel", duration: "45 Min", price: "56 €" },
            { name: "Lang", duration: "60 Min", price: "65 €" }
          ]
        },
        {
          category: "Damen Dauerwelle und Schnitt",
          items: [
            { name: "Kurz", duration: "105 Min", price: "110 €" },
            { name: "Mittel", duration: "120 Min", price: "140 €" },
            { name: "Lang", duration: "135 Min", price: "156 €" }
          ]
        }
      ]
    },
    {
      title: "Haarkuren & Behandlungen",
      services: [
        {
          category: "Pflegebehandlungen",
          items: [
            { name: "Damen Olaplex", duration: "30 Min", price: "20 €" },
            { name: "Damen Newsha Haarkur", duration: "20 Min", price: "25 €" },
            { name: "Damen Newsha Intensiv Haarkur", duration: "30 Min", price: "35 €" }
          ]
        }
      ]
    },
    {
      title: "Farbe & Coloration",
      services: [
        {
          category: "Komplettfarbe",
          items: [
            { name: "Damen Farbe komplett", duration: "90 Min", price: "ab 85 €" },
            { name: "Damen Farbe komplett Föhnen", duration: "120 Min", price: "ab 126 €" },
            { name: "Damen Farbe komplett Schnitt Föhnen", duration: "150 Min", price: "ab 134 €" }
          ]
        },
        {
          category: "Ansatzfarbe",
          items: [
            { name: "Damen Ansatzfarbe", duration: "60 Min", price: "ab 68 €" },
            { name: "Damen Ansatzfarbe Föhnen", duration: "90 Min", price: "ab 109 €" },
            { name: "Damen Ansatzfarbe Schnitt Föhnen", duration: "120 Min", price: "ab 134 €" }
          ]
        },
        {
          category: "Strähnen Oberkopf",
          items: [
            { name: "Damen Strähnen Oberkopf", duration: "75 Min", price: "ab 65 €" },
            { name: "Damen Strähnen Oberkopf Föhnen", duration: "105 Min", price: "ab 116 €" },
            { name: "Damen Strähnen Oberkopf Schnitt Föhnen", duration: "135 Min", price: "ab 141 €" }
          ]
        },
        {
          category: "Strähnen ganzer Kopf",
          items: [
            { name: "Damen Strähnen ganzer Kopf", duration: "105 Min", price: "ab 90 €" },
            { name: "Damen Strähnen ganzer Kopf Föhnen", duration: "135 Min", price: "ab 131 €" },
            { name: "Damen Strähnen ganzer Kopf Schnitt Föhnen", duration: "165 Min", price: "ab 156 €" }
          ]
        },
        {
          category: "Spezialfarben",
          items: [
            { name: "Damen Glossing", duration: "45 Min", price: "ab 30 €" },
            { name: "Damen Abmattierung", duration: "45 Min", price: "ab 30 €" },
            { name: "Damen Highlights", duration: "90 Min", price: "ab 59 €" },
            { name: "Damen Balayage Schnitt Föhnen", duration: "180 Min", price: "ab 240 €" },
            { name: "Damen Paintings", duration: "120 Min", price: "ab 50 €" }
          ]
        }
      ]
    },
    {
      title: "Haarverlängerung & Extensions",
      services: [
        {
          category: "Extensions Services",
          items: [
            { name: "Extensions Haarverlängerung", duration: "180 Min", price: "ab 250 €" },
            { name: "Haarverdichtung", duration: "150 Min", price: "ab 250 €" },
            { name: "Clip Extensions", duration: "120 Min", price: "ab 250 €" }
          ]
        }
      ]
    }
  ];

  return (
    <div className="App">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pricelist-hero">
          <div className="container mx-auto px-6 lg:px-12">
            <Link to="/" className="inline-flex items-center text-white hover:text-white/80 mb-8 group">
              <ArrowLeft className="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform" />
              <span>Zurück zur Startseite</span>
            </Link>
            <h1 className="text-4xl lg:text-6xl font-bold mb-4">Preisliste</h1>
            <p className="text-xl lg:text-2xl text-white/90 font-light">
              Transparente Preise für erstklassige Leistungen
            </p>
          </div>
        </section>

        {/* Pricelist Content */}
        <section className="section-padding bg-coconut">
          <div className="container mx-auto px-6 lg:px-12">
            <div className="space-y-16">
              {priceCategories.map((category, catIndex) => (
                <div key={catIndex}>
                  <h2 className="text-3xl lg:text-4xl font-bold mb-8 text-center">
                    {category.title}
                  </h2>
                  
                  <div className="space-y-8">
                    {category.services.map((serviceGroup, groupIndex) => (
                      <div key={groupIndex} className="pricelist-card">
                        <h3 className="text-xl font-bold mb-6 pb-4 border-b border-gray-200">
                          {serviceGroup.category}
                        </h3>
                        <div className="space-y-4">
                          {serviceGroup.items.map((item, itemIndex) => (
                            <div key={itemIndex} className="pricelist-item">
                              <div className="flex-1">
                                <div className="font-semibold text-gray-900 mb-1">
                                  {item.name}
                                </div>
                                <div className="flex items-center text-sm text-gray-600">
                                  <Clock className="w-3 h-3 mr-1" />
                                  <span>{item.duration}</span>
                                </div>
                              </div>
                              <div className="font-bold text-accent text-lg">
                                {item.price}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Booking CTA */}
            <div className="mt-16 text-center">
              <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-lg p-8 lg:p-12">
                <h3 className="text-2xl lg:text-3xl font-bold mb-4">
                  Bereit für deine Verwandlung?
                </h3>
                <p className="text-gray-600 mb-8">
                  Buche jetzt deinen Termin online und sichere dir deinen Wunschtermin
                </p>
                <a 
                  href={salonInfo.contact.treatwell}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary inline-block"
                >
                  Termin buchen
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Pricelist;
